import { Map } from 'immutable'

import { useNumPortions } from 'hooks/basket/useNumPortions'
import { useMaxRecipesForPortion } from 'hooks/menu-boxes/useMaxRecipesForPortion'

export const sumQuantities = (recipes: Map<string, number>) =>
  recipes.reduce((total = 0, current = 0) => total + current, 0)

export const useRecipeLimitExceeded = (recipes: Map<string, number>): boolean => {
  const { numPortions } = useNumPortions()
  const maxRecipesNum = useMaxRecipesForPortion(numPortions)

  return sumQuantities(recipes) > maxRecipesNum
}

export const useRecipeLimitReached = (recipes: Map<string, number>): boolean => {
  const { numPortions } = useNumPortions()
  const maxRecipesNum = useMaxRecipesForPortion(numPortions)

  return sumQuantities(recipes) >= maxRecipesNum
}
